var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-bubble-image');
import { breakpoints, theme } from '@shapeable/theme';
import { coalesce } from '../../utils/coalesce';
import { EntityTypeIcon } from './entity-type-icon';
import { ImageBubble } from '../elements/image-bubble';
import { Icon } from '../elements/icon';
import { entityTypeNameFor } from '../../utils/entity-type-name-for';
import { filter, get, includes } from 'lodash';
import { useEntityTypeIcon } from '../../hooks/use-entity-type-icons';
export var EntityBubbleImageDefaultProps = {
  size: 48,
  imageStyle: 'default'
}; // -------- Styles -------->

var IconStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border: 1px solid ", ";\n\n    ", "\n\n    .gatsby-image-wrapper {\n      img {\n        border-radius: 50%;\n      }\n    }\n\n    ", "\n\n  "], ["\n    border: 1px solid ", ";\n\n    ", "\n\n    .gatsby-image-wrapper {\n      img {\n        border-radius: 50%;\n      }\n    }\n\n    ", "\n\n  "])), theme.COLOR('line-semi-subtle'), function (props) {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      img {\n        object-fit: ", ";\n      }\n    "], ["\n      img {\n        object-fit: ", ";\n      }\n    "])), props.fit);
  }, function (props) {
    return props.fit === 'contain' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: #FFF;\n      img {\n        box-sizing: border-box;\n        padding: ", ";\n        width: 100%;\n        max-width: 100%;\n        height: 100%;\n        max-height: 100%;\n      }\n    "], ["\n      background-color: #FFF;\n      img {\n        box-sizing: border-box;\n        padding: ", ";\n        width: 100%;\n        max-width: 100%;\n        height: 100%;\n        max-height: 100%;\n      }\n    "])), theme.UNIT(props.inset));
  })
}); // -------- Components -------->

var My = {
  Image: styled(ImageBubble)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Icon: styled(Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  TypeIcon: styled(EntityTypeIcon)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var EntityBubbleImage = function EntityBubbleImage(props) {
  var className = props.className,
      entity = props.entity,
      size = props.size,
      onClick = props.onClick,
      transform = props.transform,
      alwaysShowIcon = props.alwaysShowIcon;
  var image = coalesce(entity, filter([transform, 'openGraph.image.thumbnails.full', 'openGraph.image', 'photo', 'image', 'banner.thumbnail', 'banner.image']));
  var entityTypeName = entityTypeNameFor(entity);
  var imageStyle = props.imageStyle || (includes(['Organisation'], entityTypeName) ? 'logo' : 'default');
  var transformed = get(image, transform, image);
  var hasImage = transformed && transformed.url;
  var objectFit = imageStyle === 'logo' ? 'contain' : 'cover';
  var DefaultEntityIcon = useEntityTypeIcon(entityTypeName);
  var EntityIcon = entity && entity.__icon || DefaultEntityIcon;
  var inset = Math.ceil(size / 36);
  var icon = EntityIcon && React.createElement(My.Icon, {
    onClick: onClick,
    className: cls.name(className),
    size: size
  }, React.createElement(EntityIcon, null));
  return !alwaysShowIcon && hasImage ? React.createElement(My.Image, {
    onClick: onClick,
    inset: inset,
    fit: objectFit,
    className: cls.name(className),
    size: size,
    image: transformed
  }) : icon;
};
EntityBubbleImage.defaultProps = EntityBubbleImageDefaultProps;
EntityBubbleImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;